<template>
  <div class="ei-profile-grid">
    <SmallCardWrapper
        name="Средний профиль ЭИ"
        :helpText="'Средний профиль ЭИ'"
    >
      <EiScaleRowsTable
          :sections="averageProfileSections"
          :showScaleAfterEachSection="true"
      />
    </SmallCardWrapper>

    <SmallCardWrapper
        name="Детализация ЭИ (10 разделов способностей)"
        :helpText="'Детализация ЭИ (10 разделов способностей)'"
    >
      <EiScaleRowsTable
          :sections="detailsSections"
          :showScaleAfterEachSection="false"
          :showFirstSectionTitle="true"
          class="ei-profile-details-table"
      />
    </SmallCardWrapper>
  </div>
</template>

<script>
import SmallCardWrapper from '@/components/Widgets/WidgetCard.vue'
import EiScaleRowsTable from '@/components/Analytics/EiScaleRowsTable.vue'

export default {
  name: 'EiProfileCards',

  components: {
    SmallCardWrapper,
    EiScaleRowsTable,
  },

  setup() {
    const averageProfileSections = [
      {
        title: null,
        rows: [
          {
            key: 'total_ei',
            label: 'Общий ЭИ',
            value: 110,
            color: '#9B8CFF',
            helpText: 'Среднее значение эмоционального интеллекта по выбранной группе.',
          },
        ],
      },
      {
        title: 'Домены',
        rows: [
          {
            key: 'experienced_domain',
            label: 'Опытный домен',
            value: 110,
            color: '#9B8CFF',
            helpText: 'Показатель домена опыта.',
          },
          {
            key: 'strategic_domain',
            label: 'Стратегический домен',
            value: 110,
            color: '#16B8AE',
            helpText: 'Показатель стратегического домена.',
          },
        ],
      },
      {
        title: 'Ветви',
        rows: [
          {
            key: 'emotion_recognition',
            label: 'Распознавание эмоций',
            value: 110,
            color: '#9B8CFF',
            helpText: 'Способность распознавать эмоции.',
          },
          {
            key: 'emotion_usage',
            label: 'Использование эмоций',
            value: 110,
            color: '#9B8CFF',
            helpText: 'Способность использовать эмоции для решения задач.',
          },
          {
            key: 'emotion_analysis',
            label: 'Анализ эмоций',
            value: 110,
            color: '#16B8AE',
            helpText: 'Способность анализировать эмоциональные состояния.',
          },
          {
            key: 'emotion_management',
            label: 'Управление эмоциями',
            value: 110,
            color: '#16B8AE',
            helpText: 'Способность регулировать эмоции.',
          },
        ],
      },
    ]

    const detailsSections = [
      {
        title: 'Разделы',
        rows: [
          {
            key: 'faces_recognition',
            label: 'Распознавание эмоций в лицах',
            value: 110,
            color: '#9B8CFF',
          },
          {
            key: 'environment_recognition',
            label: 'Распознавание эмоций в среде',
            value: 110,
            color: '#9B8CFF',
          },
          {
            key: 'situation_context_recognition',
            label: 'Распознавание эмоций в контексте ситуаций',
            value: 110,
            color: '#9B8CFF',
          },
          {
            key: 'emotion_application',
            label: 'Применение эмоций в действиях',
            value: 110,
            color: '#9B8CFF',
          },
          {
            key: 'empathy',
            label: 'Эмпатия',
            value: 110,
            color: '#9B8CFF',
          },
          {
            key: 'emotion_change_analysis',
            label: 'Анализ изменений эмоций',
            value: 110,
            color: '#16B8AE',
          },
          {
            key: 'emotion_connection_analysis',
            label: 'Анализ соединения эмоций в чувства',
            value: 110,
            color: '#16B8AE',
          },
          {
            key: 'emotion_dynamics_analysis',
            label: 'Анализ динамики эмоций в контексте ситуаций',
            value: 110,
            color: '#16B8AE',
          },
          {
            key: 'own_emotion_regulation',
            label: 'Регуляция своих эмоций',
            value: 110,
            color: '#16B8AE',
          },
          {
            key: 'influence_on_others',
            label: 'Влияние на эмоции других',
            value: 110,
            color: '#16B8AE',
          },
        ],
      },
    ]

    return {
      averageProfileSections,
      detailsSections,
    }
  },
}
</script>

<style scoped lang="scss">
.ei-profile-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  text-align: start;
}

.ei-profile-grid :deep(.ant-card-body) {
  padding: 0;
}

.ei-profile-grid :deep(.small-card-wrapper__body) {
  align-items: stretch;
}

.ei-profile-details-table {
  min-height: 370px;
}

@media (max-width: $tablet-breakpoint) {
  .ei-profile-grid {
    grid-template-columns: 1fr;
  }
}
</style>